export const ModuleTabs = ({ value, onChange, MODULES }) => {
  return (
    <div className="w-full">
      {/* Mobile: left align + scroll | Desktop: normal */}
      <div className="flex items-center justify-start md:justify-start overflow-x-auto no-scrollbar">
        <div className="inline-flex flex-nowrap items-center rounded-2xl border border-orange-200 bg-orange-50/60 px-1.5 py-1 shadow-sm">

          {MODULES.map((m) => {
            const active = value === m.key;

            return (
              <button
                key={m.key}
                type="button"
                onClick={() => onChange(m.key)}
                className={[
                  "relative inline-flex items-center justify-center gap-2 whitespace-nowrap",
                  "rounded-xl font-semibold transition-all duration-200",
                  "focus:outline-none focus:ring-2 focus:ring-orange-300",

                  // ✅ Mobile sizing
                  "px-3 py-2 text-[12px] leading-none",
                  // ✅ Desktop sizing
                  "sm:px-5 sm:py-2 sm:text-sm",

                  active
                    ? "bg-gradient-to-r from-orange-600 to-amber-500 text-white shadow-md"
                    : "text-orange-900 hover:bg-white hover:shadow-sm",
                ].join(" ")}
              >
                <div className="hidden md:block">

                {m.icon && (
                  <span className={active ? "opacity-100" : "opacity-70"}>
                    {m.icon}
                  </span>
                )}
                </div>

                <span>{m.label}</span>

                {/* active glow line */}
                {active && (
                  <span className="absolute -bottom-1 left-5 right-5 h-1 rounded-full bg-orange-400/50 blur-[2px]" />
                )}
              </button>
            );
          })}

        </div>
      </div>
    </div>
  );
};